// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/PaymentPage.css
.payment-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  /* background: #89CFF0; Updated backgroundssss color */
/* }

.payment-container {
  display: flex;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.payment-details, .order-summary {
  padding: 20px;
  flex: 1;
}

.plan-details, .billing-cycle {
  margin-bottom: 20px;
}

.user-count button, .cycle-options button {
  margin: 5px;
  padding: 10px;
  border: 1px solid #ccc;
  background: none;
  cursor: pointer;
}

.cycle-options button.active {
  background-color: #00A300;
  color: white;
}

.order-summary {
  border-left: 1px solid #eee;
}

.summary-item, .total {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}

.continue-button {
  width: 20%;
  padding: 10px;
  background-color: #00A300;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.back-button {
  background-color: #00A300;
  color: white;
  margin-right: 10px; /* Add margin to the right of the back button */
/* }
.button-group {
  display: flex;
  gap: 10px; /* Ensure a gap between the buttons */
/* } */ 


.payment-page {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 80vh;
  background: #f8f8f8;
}

.payment-container {
  display: flex;
  width: 100%;
  max-width: 1200px;
  min-height: 80vh;
  background: white;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.payment-details {
  flex: 2 1;
  padding: 20px;
  background-color: #fff;
  border-right: 2px solid #ccc;
  height: 100%;
}

.order-summary {
  flex: 1 1;
  padding: 40px;
  background-color: #fff;
  height: 100%;
}

.plan-details, .billing-cycle {
  margin-bottom: 20px;
}

.user-count {
  display: flex;
  align-items: center;
}

.user-count button {
  margin: 0 10px;
  padding: 10px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.cycle-options {
  display: flex;
  gap: 20px;
}

.cycle-options button {
  padding: 10px;
  border: 2px solid #ccc;
  background: none;
  cursor: pointer;
  border-radius: 5px;
}

.cycle-options button.active {
  border: 3px solid #0b72b9;
}

.order-summary h3 {
  margin-bottom: 20px;
}

.summary-item, .total {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}

.continue-button {
  width: 100%;
  padding: 15px;
  background-color: #0b72b9;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
}

.button-group {
  display: flex;
  gap: 20px;
}

.feature-option {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/* Checkbox styling */
.feature-option input[type="checkbox"] {
  appearance: none;
  background-color: #fff;
  border: 2px solid #ccc;
  padding: 10px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

/* Checked state: blue background and tick */
.feature-option input[type="checkbox"]:checked {
  background-color: #0b72b9; /* Blue background */
  border-color: #0b72b9; /* Blue border */
}

.feature-option input[type="checkbox"]:checked::after {
  /* content: "✅"; */
  font-size: 12px;
  position: absolute;
  top: -2px;
  left: 2px;
  color: white; /* White tick */
}

.feature-option label {
  margin: 0 10px;
  cursor: pointer;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/PaymentPage.css"],"names":[],"mappings":"AAAA;;;;;;wDAMwD;AACxD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;qEAuDqE;AACrE;;;kDAGkD;AAClD,MAAM;;;AAGN;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,qBAAqB,EAAE,gBAAgB;AACzC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY,EAAE,eAAe;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb","sourcesContent":["/* src/PaymentPage.css\n.payment-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  /* background: #89CFF0; Updated backgroundssss color */\n/* }\n\n.payment-container {\n  display: flex;\n  padding: 20px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\n}\n\n.payment-details, .order-summary {\n  padding: 20px;\n  flex: 1;\n}\n\n.plan-details, .billing-cycle {\n  margin-bottom: 20px;\n}\n\n.user-count button, .cycle-options button {\n  margin: 5px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  background: none;\n  cursor: pointer;\n}\n\n.cycle-options button.active {\n  background-color: #00A300;\n  color: white;\n}\n\n.order-summary {\n  border-left: 1px solid #eee;\n}\n\n.summary-item, .total {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n}\n\n.continue-button {\n  width: 20%;\n  padding: 10px;\n  background-color: #00A300;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.back-button {\n  background-color: #00A300;\n  color: white;\n  margin-right: 10px; /* Add margin to the right of the back button */\n/* }\n.button-group {\n  display: flex;\n  gap: 10px; /* Ensure a gap between the buttons */\n/* } */ \n\n\n.payment-page {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 80vh;\n  background: #f8f8f8;\n}\n\n.payment-container {\n  display: flex;\n  width: 100%;\n  max-width: 1200px;\n  min-height: 80vh;\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.payment-details {\n  flex: 2;\n  padding: 20px;\n  background-color: #fff;\n  border-right: 2px solid #ccc;\n  height: 100%;\n}\n\n.order-summary {\n  flex: 1;\n  padding: 40px;\n  background-color: #fff;\n  height: 100%;\n}\n\n.plan-details, .billing-cycle {\n  margin-bottom: 20px;\n}\n\n.user-count {\n  display: flex;\n  align-items: center;\n}\n\n.user-count button {\n  margin: 0 10px;\n  padding: 10px;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.cycle-options {\n  display: flex;\n  gap: 20px;\n}\n\n.cycle-options button {\n  padding: 10px;\n  border: 2px solid #ccc;\n  background: none;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.cycle-options button.active {\n  border: 3px solid #0b72b9;\n}\n\n.order-summary h3 {\n  margin-bottom: 20px;\n}\n\n.summary-item, .total {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n}\n\n.continue-button {\n  width: 100%;\n  padding: 15px;\n  background-color: #0b72b9;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.button-group {\n  display: flex;\n  gap: 20px;\n}\n\n.feature-option {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n/* Checkbox styling */\n.feature-option input[type=\"checkbox\"] {\n  appearance: none;\n  background-color: #fff;\n  border: 2px solid #ccc;\n  padding: 10px;\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  border-radius: 4px;\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n}\n\n/* Checked state: blue background and tick */\n.feature-option input[type=\"checkbox\"]:checked {\n  background-color: #0b72b9; /* Blue background */\n  border-color: #0b72b9; /* Blue border */\n}\n\n.feature-option input[type=\"checkbox\"]:checked::after {\n  /* content: \"✅\"; */\n  font-size: 12px;\n  position: absolute;\n  top: -2px;\n  left: 2px;\n  color: white; /* White tick */\n}\n\n.feature-option label {\n  margin: 0 10px;\n  cursor: pointer;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
